import { __awaiter as n, __generator as s } from "./index11.js";
import { invokeCallback as d } from "./index51.js";
var u = function(i, r) {
  var l = Date.now() - i;
  return Math.max((r ?? 300) - l, 0);
};
function h(i, r, l, e) {
  return n(this, void 0, void 0, function() {
    var c, a;
    return s(this, function(t) {
      switch (t.label) {
        case 0:
          return l.emit("dispatch_start", i), c = Date.now(), r.isEmpty() ? [4, r.dispatchSingle(i)] : [3, 2];
        case 1:
          return a = t.sent(), [3, 4];
        case 2:
          return [4, r.dispatch(i)];
        case 3:
          a = t.sent(), t.label = 4;
        case 4:
          return e?.callback ? [4, d(a, e.callback, u(c, e.timeout))] : [3, 6];
        case 5:
          a = t.sent(), t.label = 6;
        case 6:
          return e?.debug && a.flush(), [2, a];
      }
    });
  });
}
export {
  h as dispatch,
  u as getDelay
};
//# sourceMappingURL=index22.js.map
